// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Mlnt","name":"styles_name__2STmk","phone":"styles_phone__DErws"};